import React, { useState } from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, ClockIcon, SendIcon, MessageSquareIcon } from 'lucide-react';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    await new Promise(resolve => setTimeout(resolve, 1500));
    setIsSubmitting(false);
    setIsSubmitted(true);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1208">
      {/* Hero */}
      <div className="bg-primary-600 py-16" data-id="element-1209">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-1210">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-1211">
            Contact Us
          </h1>
          <p className="text-primary-100 max-w-2xl mx-auto" data-id="element-1212">
            Have questions? We'd love to hear from you. Send us a message and
            we'll respond as soon as possible.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-1213">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1214">
          {/* Contact info */}
          <div className="space-y-6" data-id="element-1215">
            <Card padding="lg" data-id="element-1216">
              <div className="flex items-start gap-4" data-id="element-1217">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1218">
                  <MailIcon className="w-6 h-6 text-primary-600" data-id="element-1219" />
                </div>
                <div data-id="element-1220">
                  <h3 className="font-semibold text-gray-900" data-id="element-1221">Email Us</h3>
                  <p className="text-gray-600 text-sm mt-1" data-id="element-1222">
                    We'll respond within 24 hours
                  </p>
                  <a href="mailto:waqas.nizam@paysyslabs.com" className="text-primary-600 hover:text-primary-700 font-medium mt-2 block" data-id="element-1223">
                    waqas.nizam@paysyslabs.com
                  </a>
                </div>
              </div>
            </Card>

            <Card padding="lg" data-id="element-1224">
              <div className="flex items-start gap-4" data-id="element-1225">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1226">
                  <PhoneIcon className="w-6 h-6 text-green-600" data-id="element-1227" />
                </div>
                <div data-id="element-1228">
                  <h3 className="font-semibold text-gray-900" data-id="element-1229">Call Us</h3>
                  <p className="text-gray-600 text-sm mt-1" data-id="element-1230">
                    Mon-Sat from 9am to 9pm
                  </p>
                  <a href="tel:+923132370605" className="text-primary-600 hover:text-primary-700 font-medium mt-2 block" data-id="element-1231">
                    +92-313-2370605
                  </a>
                </div>
              </div>
            </Card>

            <Card padding="lg" data-id="element-1232">
              <div className="flex items-start gap-4" data-id="element-1233">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1234">
                  <MapPinIcon className="w-6 h-6 text-primary-600" data-id="element-1235" />
                </div>
                <div data-id="element-1236">
                  <h3 className="font-semibold text-gray-900" data-id="element-1237">Visit Us</h3>
                  <p className="text-gray-600 text-sm mt-1" data-id="element-1238">
                    Gadgets Zone
                    <br data-id="element-1239" />
                    Karachi, Pakistan
                  </p>
                </div>
              </div>
            </Card>

            <Card padding="lg" data-id="element-1240">
              <div className="flex items-start gap-4" data-id="element-1241">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1242">
                  <ClockIcon className="w-6 h-6 text-purple-600" data-id="element-1243" />
                </div>
                <div data-id="element-1244">
                  <h3 className="font-semibold text-gray-900" data-id="element-1245">
                    Business Hours
                  </h3>
                  <div className="text-gray-600 text-sm mt-2 space-y-1" data-id="element-1246">
                    <p data-id="element-1247">Monday - Saturday: 9:00 AM - 9:00 PM</p>
                    <p data-id="element-1248">Sunday: 11:00 AM - 7:00 PM</p>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          {/* Contact form */}
          <div className="lg:col-span-2" data-id="element-1249">
            <Card padding="lg" data-id="element-1250">
              <div className="flex items-center gap-3 mb-6" data-id="element-1251">
                <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center" data-id="element-1252">
                  <MessageSquareIcon className="w-5 h-5 text-primary-600" data-id="element-1253" />
                </div>
                <div data-id="element-1254">
                  <h2 className="text-xl font-semibold text-gray-900" data-id="element-1255">
                    Send us a Message
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-1256">
                    Fill out the form below and we'll get back to you
                  </p>
                </div>
              </div>

              {isSubmitted ? <div className="text-center py-12" data-id="element-1257">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1258">
                    <SendIcon className="w-8 h-8 text-green-600" data-id="element-1259" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-1260">
                    Message Sent!
                  </h3>
                  <p className="text-gray-600" data-id="element-1261">
                    Thank you for contacting us. We'll get back to you within 24
                    hours.
                  </p>
                  <Button variant="outline" className="mt-6" onClick={() => {
                setIsSubmitted(false);
                setFormData({
                  name: '',
                  email: '',
                  phone: '',
                  subject: '',
                  message: ''
                });
              }} data-id="element-1262">
                    Send Another Message
                  </Button>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1263">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1264">
                    <Input label="Full Name" placeholder="Your name" value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} required data-id="element-1265" />
                    <Input label="Email Address" type="email" placeholder="your@email.com" value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} required data-id="element-1266" />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1267">
                    <Input label="Phone Number" type="tel" placeholder="+92-XXX-XXXXXXX" value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} data-id="element-1268" />
                    <Input label="Subject" placeholder="How can we help?" value={formData.subject} onChange={e => setFormData({
                  ...formData,
                  subject: e.target.value
                })} required data-id="element-1269" />
                  </div>

                  <div data-id="element-1270">
                    <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-1271">
                      Message
                    </label>
                    <textarea rows={6} placeholder="Tell us more about your inquiry..." value={formData.message} onChange={e => setFormData({
                  ...formData,
                  message: e.target.value
                })} className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 transition-all duration-200 resize-none" required data-id="element-1272" />
                  </div>

                  <Button type="submit" variant="primary" size="lg" isLoading={isSubmitting} leftIcon={<SendIcon className="w-4 h-4" data-id="element-1274" />} data-id="element-1273">
                    Send Message
                  </Button>
                </form>}
            </Card>
          </div>
        </div>

        {/* Map placeholder */}
        <div className="mt-12" data-id="element-1275">
          <Card padding="none" className="overflow-hidden" data-id="element-1276">
            <div className="h-80 bg-gray-200 flex items-center justify-center" data-id="element-1277">
              <div className="text-center" data-id="element-1278">
                <MapPinIcon className="w-12 h-12 text-gray-400 mx-auto mb-2" data-id="element-1279" />
                <p className="text-gray-500" data-id="element-1280">Map integration would go here</p>
                <p className="text-sm text-gray-400" data-id="element-1281">Karachi, Pakistan</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}